export const certificado = {
  meus: {
    title: 'Meus Certificados',
    description: 'Certificados emitidos pelas trilhas e cursos que você concluiu.',
    empty: {
      title: 'Você ainda não tem certificados.',
      description: 'Conclua uma trilha ou curso para emitir o seu.',
    },
    emitidoEm: 'Emitido em',
    baixarPdf: 'Baixar PDF',
    verificar: 'Verificar',
    pdf: {
      sucesso: 'Download iniciado.',
      erro: 'Não foi possível gerar o PDF agora.',
    },
  },
  tipo: {
    trilha: 'Trilha',
    curso: 'Curso',
  },
  verify: {
    loading: 'Verificando certificado...',
    valido: {
      title: 'Certificado válido',
      subtitle: 'Autenticidade confirmada pelo NT Academy.',
      concluiu: 'concluiu',
      concluidoEm: 'Concluído em',
      emitidoEm: 'Emitido em',
      codigo: 'Código',
    },
    naoEncontrado: {
      title: 'Certificado não encontrado',
      description: 'Não há certificado válido para este endereço.',
      hint: 'Verifique o link ou o código informado.',
    },
    erro: {
      title: 'Não foi possível verificar agora.',
      description: 'Tente novamente em instantes.',
    },
  },
} as const;
